/**
 * useCurrentShift — fetch поточна відкрита зміна для workstation+касира.
 *
 * Запитує GET /retail/cash-shift-open?pos_workstation_id=X&shift_status=open
 * і повертає перший з них (зазвичай 1 відкрита зміна на workstation).
 */
import { useQuery } from '@tanstack/react-query';
import { retailCashShiftOpens, type CashShiftOpen } from '@/api/retailCashShiftOpen';

export function useCurrentShift(workstationId: string | null) {
  const q = useQuery({
    queryKey: ['pos-current-shift', workstationId ?? ''],
    queryFn: () =>
      retailCashShiftOpens.list({
        pos_workstation_id: workstationId ?? undefined,
        shift_status: 'open',
        posted: true,
        limit: 1,
      }),
    enabled: !!workstationId,
    staleTime: 30 * 1000,
  });

  const shift: CashShiftOpen | null = q.data?.items[0] ?? null;

  return {
    shift,
    isLoading: q.isLoading,
    isError: q.isError,
    error: q.error,
    refetch: q.refetch,
  };
}
